export default "__VITE_ASSET__TWzqWYlw__"